export default {
  paged: {
    select: 'id,isActive,order,name,powerBIReportGroupId,powerBIServerConfigurationId',
    searchSelect: ['name', 'powerBIReportGroupId'],
    orderBy: 'order',
    expand: {
      powerBIServerConfiguration: { select: 'id,name' },
    },
  },
  item: {
    select:
      'id,isActive,order,name,powerBIReportGroupId,powerBIServerConfigurationId,permissionsFiltersLogicalOperator',
    expand: {
      powerBIServerConfiguration: { select: 'id,name' },
    },
  },
  itemDetail: {
    select:
      'id,isActive,order,name,powerBIReportGroupId,permissionsFiltersLogicalOperator,created,updated',
    expand: {
      powerBIServerConfiguration: { select: 'id,name' },
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
